import { lazy } from 'react';

export const LogoutPageAsync = lazy(() => import('./LogoutPage'));
